import HighlightedVenue from './HighlightedVenue';

export default HighlightedVenue;
